import { gql } from '@apollo/client';

export const APPOINTMENT_SERVICES_AND_BRANCHES = gql`
  query appointmentServicesAndBranches(
    $customerType: SmartBookingCustomerType
  ) {
    consultationServices(customerType: $customerType) {
      name
      id
      customerType
      types {
        type
        availableServiceLocation {
          name
          id
          branchId
          region
        }
      }
    }
  }
`;
